/**
 * Validates if an address contains a street number, street name, city, and state
 * @param address - The address string to validate
 * @returns boolean - true if valid, false otherwise
 */
export const validateStreetAddress = (address: string): boolean => {
    if (!address) return false;

    const trimmedAddress = address.trim();

    // Must contain a street number and street name
    const hasStreetNumber = /^\d+[\w\-]*\s+/.test(trimmedAddress) ||
        /\b(?:west|east|north|south|w\.?|e\.?|n\.?|s\.?)?\s*\d+[\w\-]*(?:st|nd|rd|th)?\s+(?:street|st|avenue|ave|road|rd|boulevard|blvd|lane|ln|drive|dr|court|ct|circle|cir|way|place|pl|parkway|pkwy|terrace|ter|trail|trl|highway|hwy)\b/i.test(trimmedAddress) ||
        /\d+[\w\-]*\s+[A-Za-z\s]+(?:street|st|avenue|ave|road|rd|boulevard|blvd|lane|ln|drive|dr|court|ct|circle|cir|way|place|pl|parkway|pkwy|terrace|ter|trail|trl|highway|hwy|alley|loop|plaza|square|path|walk|run|crossing|xing|pike|row|green|point|pt|ridge|heights|crescent|mill|fork|creek|bend|bay|cove|glen|grove|hill|knoll|park|vista|branch|bridge|hollow|summit|valley|woods|acres|common|corner|manor|meadow|view|pass)\b/i.test(trimmedAddress);

    if (!hasStreetNumber) {
        return false;
    }

    // Must contain a comma (indicating city separation)
    const hasComma = /,/.test(trimmedAddress);

    if (!hasComma) {
        return false;
    }

    // Must contain a US state (abbreviated or full name)
    const statePattern = /\b(AL|AK|AZ|AR|CA|CO|CT|DE|FL|GA|HI|ID|IL|IN|IA|KS|KY|LA|ME|MD|MA|MI|MN|MS|MO|MT|NE|NV|NH|NJ|NM|NY|NC|ND|OH|OK|OR|PA|RI|SC|SD|TN|TX|UT|VT|VA|WA|WV|WI|WY|Alabama|Alaska|Arizona|Arkansas|California|Colorado|Connecticut|Delaware|Florida|Georgia|Hawaii|Idaho|Illinois|Indiana|Iowa|Kansas|Kentucky|Louisiana|Maine|Maryland|Massachusetts|Michigan|Minnesota|Mississippi|Missouri|Montana|Nebraska|Nevada|New Hampshire|New Jersey|New Mexico|New York|North Carolina|North Dakota|Ohio|Oklahoma|Oregon|Pennsylvania|Rhode Island|South Carolina|South Dakota|Tennessee|Texas|Utah|Vermont|Virginia|Washington|West Virginia|Wisconsin|Wyoming)\b/i;

    const hasState = statePattern.test(trimmedAddress);

    return hasState;
};
